import React from 'react'
import { UUITheme } from '../types'

const UUIThemeContext = React.createContext<UUITheme | undefined>(undefined)

export default UUIThemeContext
